import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 数量単位 */
enum QuantityUnit {
  piece = '10',
  unit = '11',
  house = '12',
  setting = '13',
}

const nameConfig = {
  piece: new Map([
    [Locale.ja, '個'],
    [Locale.en, 'Piece'],
  ]),
  unit: new Map([
    [Locale.ja, '台'],
    [Locale.en, 'Unit'],
  ]),
  house: new Map([
    [Locale.ja, '軒'],
    [Locale.en, 'House'],
  ]),
  setting: new Map([
    [Locale.ja, '式'],
    [Locale.en, 'Setting'],
  ]),
};

const toEnum = rawValueToEnum(QuantityUnit, '');
const toDisplay = enumToName(QuantityUnit, nameConfig);
const toDisplayWithPrefix = enumToName(QuantityUnit, nameConfig, { prefix: true });

export const quantityUnit = {
  enum: QuantityUnit,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { QuantityUnit };
